import apolloService from './apolloService';

export default apolloService;
